export default __webpack_public_path__ + "static/media/README.48053491.md";